import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {Inject} from 'inversify-props';

import {NetworkingStatus} from '@/model/network/Networking';

import {INetworkNetworkingService} from '@/services/network/INetworkNetworkingService';

@Module({name: 'NetworkNetworkingStore', namespaced: true})
export default class NetworkNetworkingStore extends VuexModule {
  private status: NetworkingStatus | null = null;
  private hostname: string | null = null;

  @Inject(Symbol.for('INetworkNetworkingService'))
  private networkingService!: INetworkNetworkingService;

  /* STATUS */
  @Action({commit: 'setStatus', rawError: true})
  public async fetchStatus() {
    return await this.networkingService.status();
  }

  @Mutation
  public setStatus(status: NetworkingStatus) {
    this.status = status;
  }

  public get Status(): NetworkingStatus | null {
    return this.status;
  }


  @Action({commit: 'setHostname', rawError: true})
  public async fetchHostname() {
    return await this.networkingService.getHostname();
  }

  @Mutation
  public setHostname(hostname: string) {
    this.hostname = hostname;
  }

  public get Hostname(): string | null {
    return this.hostname;
  }
}
